import React from 'react';
import { useRefinementList } from 'react-instantsearch';

const FeaturedTopics = ({ attribute }) => {
    const { items, refine } = useRefinementList({ attribute });

    return (
        <div>
            {items.map((item) => (
                <label className="toggleButton" key={item.label}>
                    <input
                        type="checkbox"
                        name="topic"
                        value={item.value}
                        className="toggleButton__checkbox js-search-filter-param"
                        onChange={() => {
                            refine(item.value);
                        }}
                        checked={item.isRefined ? 'checked' : ''}
                    />
                    <span className="toggleButton__label">{item.label}</span>
                </label>
            ))}
        </div>
    );
};

export default FeaturedTopics;
